import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import DigiDocImage from "../../Assets/Images/DigiDoc Head.png";
import SplashImage from "../../Assets/Images/Online Doctor-amico.png";
import "./Signin.css";
import config from "../../Config";

const Signin = () => {
  const [mobileNumber, setMobileNumber] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleMobileNumberChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setMobileNumber(value);
      setErrorMessage("");
    } else {
      setErrorMessage("Please enter a valid mobile number");
    }
  };
const handleContinue = async (e) => {
  e.preventDefault();
  if (mobileNumber.length === 10) {
    setLoading(true);
    try {
      const response = await fetch(`${config.API_BASE_URL}/patient/send_otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          mobile_no: mobileNumber,
          language: "1", // Language ID for English
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to send OTP");
      }

      const result = await response.json();
      console.log(result); // Log the response for debugging

      // Ensure that the response contains the expected data
      if (result && result.data) {
        const { patient_id: patientid } = result.data; // Extract patient_id
        console.log("Patient ID:", patientid); // Log patient ID for debugging

        // Save patientid and mobile number in sessionStorage
        sessionStorage.setItem("mobileNumber", mobileNumber);
        sessionStorage.setItem("patientid", patientid);

        navigate("/otp", { state: { mobileNumber } });
      } else {
        setErrorMessage("Invalid response from the server.");
      }
    } catch (error) {
      setErrorMessage("An error occurred while sending OTP. Please try again.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  } else {
    setErrorMessage("Mobile number must be 10 digits");
  }
};


  return (
    <div className="form-container">
      <header className="logo-section">
        <img src={DigiDocImage} alt="DigiDoc" className="logo" />
      </header>
      <div className="illustration-section">
        <img src={SplashImage} alt="Doctor Illustration" className="illustration" />
      </div>
      <form className="sign-in-form" onSubmit={handleContinue}>
        <div className="divider"></div>
        <h2>Sign in/Sign up</h2>
        <input
          type="text"
          placeholder="Enter mobile number"
          className="mobile-input"
          value={mobileNumber}
          onChange={handleMobileNumberChange}
          maxLength="10"
          required
        />
        {errorMessage && <p className="error-message">{errorMessage}</p>}
        <button type="submit" disabled={loading}>
          {loading ? "Loading..." : "Continue"}
        </button>
      </form>
    </div>
  );
};

export default Signin;
